module.exports = __webpack_public_path__ + "img/tg1.e874eb9b.png";